import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const buy_requestsApi = createAsyncThunk(
  "buy_requests",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/buy_requests", { params });

    return response?.data;
  }
);

const buy_requestsSlice = createSlice({
  name: "buy_requests",
  initialState: {
    buy_requests: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(buy_requestsApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(buy_requestsApi.fulfilled, (state, action) => {
        state.buy_requests = action.payload;
        state.loading = false;
      })
      .addCase(buy_requestsApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default buy_requestsSlice.reducer;
